import { Component, inject } from '@angular/core';
import { AuthService } from 'core/services/auth.service';
import { MyReferralsMyInfoSpecialComponent } from './my-referrals-my-info-special/my-referrals-my-info-special.component';
import { MyReferralsMyInfoDefaultComponent } from './my-referrals-my-info-default/my-referrals-my-info-default.component';

@Component({
  selector: 'app-my-referrals-my-info',
  imports: [MyReferralsMyInfoSpecialComponent, MyReferralsMyInfoDefaultComponent],
  templateUrl: './my-referrals-my-info.component.html',
  styleUrl: './my-referrals-my-info.component.scss'
})
export class MyReferralsMyInfoComponent {
  #authService = inject(AuthService);

  get currentUserIsSpecial(): boolean {
    return this.#authService.currentUser?.isSpecial;
  }
}
